import {configureStore} from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import queueSlice from './slices/queueSlice';

export const store = configureStore({
	reducer: {
		user: userReducer,
		queue: queueSlice,
	},
});

